import { z } from 'zod'

const envSchema = z.object({
  VITE_BFF_API_URL: z.url(),
  VITE_COGNITO_USER_POOL_ID: z.string().min(1),
  VITE_COGNITO_CLIENT_ID: z.string().min(1),
  VITE_AWS_REGION: z.string().min(1),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']),
  // Dev-only escape hatch: bypass Cognito so the UI can be previewed without
  // real credentials. Has no effect when VITE_APP_ENV !== 'development'.
  VITE_DEV_BYPASS_AUTH: z
    .enum(['true', 'false'])
    .optional()
    .transform((v) => v === 'true'),
})

export const env = envSchema.parse(import.meta.env)
